import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=3c35a03c&scoped=true&"
import script from "./activity.vue?vue&type=script&lang=js&"
export * from "./activity.vue?vue&type=script&lang=js&"
import style0 from "./activity.vue?vue&type=style&index=0&lang=css&"
import style1 from "./activity.vue?vue&type=style&index=1&id=3c35a03c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c35a03c",
  null
  
)

export default component.exports